exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-result-title[data-v-58744b44]{color:var(--secondary-color);font-family:artifaktElementBold;font-size:20px;font-weight:700;cursor:pointer}.search-results-panel[data-v-58744b44]{background-color:#fff;color:#979797;font-size:14px;margin-bottom:10px!important;margin-top:0!important;margin-left:0!important;margin-right:0!important;padding:15px!important;min-height:80px;border:1px solid #64788d;border-radius:3px}.search-results-panel a[data-v-58744b44]:hover{color:#0056b3;text-decoration:none}.search-result-desc[data-v-58744b44]{color:#000;font-size:16px}", ""]);

// exports
